import React from 'react';
import { useCheckIncludeProfiles } from '@/app/hooks/useAuthorityLevel';
import Error404 from 'src/app/components/Error404';
import WeekChallengeSidebar from './WeekChallengeSidebar';
import WeekChallengeContent from './WeekChallengeContent';

export default function CreateWeekChallenge() {
  const isAdmin = !useCheckIncludeProfiles({ only: ['student'] });

  if (!isAdmin) return <Error404 />;

  return (
    <div className="main-screen">
      <WeekChallengeSidebar />

      <div className="main-content main-content--admin-layout">
        <WeekChallengeContent />
      </div>
    </div>
  );
}
